module.exports = __webpack_public_path__ + "img/116.b5a6847c.png";